import { createAction } from '../common';
export const SET_CARD_NAME = 'setCardName';
export const setCardNameAction = createAction(SET_CARD_NAME);

export const SET_CARD_NUMBER = 'setCardNumber';
export const setCardNumberAction = createAction(SET_CARD_NUMBER);

export const SET_CARD_DATE = 'setCardDate';
export const setCardDateAction = createAction(SET_CARD_DATE);

export const SET_CARD_CVV = 'setCardCVV';
export const setCardCVCAction = createAction(SET_CARD_CVV);

export const SET_CARD_ZIP = 'setCardZip';
export const setCardZipAction = createAction(SET_CARD_ZIP);

export const SET_CARD_ERR = 'setCardErr';
export const setErrorAction = createAction(SET_CARD_ERR);

export const SET_CARD_VALIDITY = 'setCardValidity';
export const setCardValidityAction = createAction(SET_CARD_VALIDITY);

export const SET_CARD_BRAND = 'setCardBrand';
export const setCardBrandAction = createAction(SET_CARD_BRAND);

export const SET_LAST_FOUR = 'setLastFour';
export const setLastFourAction = createAction(SET_LAST_FOUR);

export const VALIDATE_CARD = 'validateCard';
export const validateCardAction = createAction(VALIDATE_CARD);
